import React from 'react';
import Box from '@mui/material/Box';

export const highlightMatch = (
    text: string,
    query: string,
    highlightColor: string,
): React.ReactNode => {
    if (!query) return text;

    const index = text.toLowerCase().indexOf(query.toLowerCase());
    if (index === -1) return text;

    return (
        <>
            {text.substring(0, index)}
            <Box component="span" sx={{ color: highlightColor }}>
                {text.substring(index, index + query.length)}
            </Box>
            {text.substring(index + query.length)}
        </>
    );
};
